import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/challenge-configuration',
            name: 'challenge Configuration',
            component: () => import("./views/challengeConfiguration.vue")
        },
    ];
};